import actions from './actions';
import mutations from './mutations';

const state = {
    isOpen: false,
    isConfirm: false,
    title: '確認',
    message: '',
    ok: 'OK',
    cancel: 'キャンセル',
    resolve: (bool) => bool,
    reject: (bool) => bool,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};